"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorGraphic = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var use_id_1 = require("@hopin-team/use-id");
var react_1 = tslib_1.__importDefault(require("react"));
var root_1 = require("./styled/root");
var VectorGraphic = function (_a) {
    var className = _a.className, __UIScope = _a.__UIScope, testID = _a["data-testid"], labelledBy = _a["aria-labelledby"], children = _a.children, title = _a.title, description = _a.description, _b = _a.fill, fill = _b === void 0 ? 'none' : _b, id = _a.id, rest = tslib_1.__rest(_a, ["className", "__UIScope", 'data-testid', 'aria-labelledby', "children", "title", "description", "fill", "id"]);
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'VectorGraphic',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    var _id = (0, use_id_1.useId)(id);
    var titleId = "".concat(_id, "-title");
    var descriptionId = "".concat(_id, "-description");
    var a11yProps = {};
    // Empty aria-labelledby/aria-describedby is a violation, so only adding the prop if the
    // title/labelledBy or description exists.
    if (description) {
        a11yProps['aria-describedby'] = descriptionId;
    }
    if (labelledBy || title) {
        a11yProps['aria-labelledby'] = labelledBy !== null && labelledBy !== void 0 ? labelledBy : titleId;
    }
    return (react_1.default.createElement(root_1.Root, tslib_1.__assign({ className: rootClasses, "data-testid": testID, fill: fill, role: "img", xmlns: "http://www.w3.org/2000/svg" }, a11yProps, rest),
        title && react_1.default.createElement("title", { id: titleId }, title),
        description && react_1.default.createElement("desc", { id: descriptionId }, description),
        children));
};
var VectorGraphicWithSpace = (0, ui_helper_with_space_1.withSpace)(VectorGraphic);
exports.VectorGraphic = VectorGraphicWithSpace;
//# sourceMappingURL=vector-graphic.js.map